import React, { Fragment } from 'react';
import CCopyToClipboard from '@/components/CopyableText/CCopyToClipboard';
import { placeholder } from '@bluevision/tools';

type Props = {
  value?: string | null | number;
};

const CopyableText: React.FC<Props> = ({ value }) => (
  <Fragment>
    {value === null || value === undefined ? (
      placeholder
    ) : (
      <CCopyToClipboard value={`${value}`.trim()} />
    )}
  </Fragment>
);

export default CopyableText;
